
export default class CacheStore {
  public static MENU_PINNED = 'MENU_PINNED'
  public static TOKEN = 'TOKEN'
  public static COLUMN_ORDER_SLOT = 'FLive.Table.Column.Preferences'

  public static get (key: string): any {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : item
  }

  public static set (key: string, input: any) {
    localStorage.setItem(key, JSON.stringify(input))
  }

  public static remove (key: string) {
    localStorage.removeItem(key)
  }

  public static setToSession (key: string, input: any) {
    sessionStorage.setItem(key, JSON.stringify(input))
  }

  public static getFromSession (key: string): any {
    const item = sessionStorage.getItem(key)
    return item ? JSON.parse(item) : item
  }

  public static removeFromSession (key: string) {
    sessionStorage.removeItem(key)
  }
}
